
export const CARE_GUIDE_CATEGORY_ID = "care-guide";

export const PROVIDER_CATEGORIES = [
  {
    id: CARE_GUIDE_CATEGORY_ID,
    label: "Care Guide",
    creditKey: undefined,
    matchKeywords: ["care guide", "15 minute", "introduction", "free call"],
  },
  {
    id: "clinician",
    label: "Clinician",
    creditKey: "clinician",
    matchKeywords: ["clinician"],
  },
  {
    id: "fertility-doula",
    
    label: "Fertility Doula",
    creditKey: "fertilityDoula",
    matchKeywords: ["doula", "fertility", "coach", "educator", "support"],
  },
  {
    id: "nutritionist",
    label: "Nutritionist",
    creditKey: "nutritionist",
    matchKeywords: ["nutrition"],
  },
];

// Care Guide is a free 15-minute receptionist-style call: no intake forms, no payment, no
// credits, unlimited booking. It is not a Fertility Doula.
export function isCareGuideCategory(categoryId) {
  return categoryId === CARE_GUIDE_CATEGORY_ID;
}

export function categoryForGroupName(groupName) {
  const n = String(groupName || "").toLowerCase();
  return PROVIDER_CATEGORIES.find((c) => c.matchKeywords.some((k) => n.includes(k))) || null;
}

export function categoryForCreditKey(creditKey) {
  return PROVIDER_CATEGORIES.find((c) => c.creditKey === creditKey) || null;
}

export const CREDIT_BEARING_CATEGORIES = PROVIDER_CATEGORIES.filter((c) => !!c.creditKey);

// Backend CreditType.Code (Patient/GetCreditBalance) -> this app's creditKey.
// CreditType was migrated (see MyFertilityAPI/SqlScripts/20260827) from one row per specific
// provider category (Doctor, Nurse Practitioner, Coach, ...) down to exactly 3 pooled group rows
// - Clinician / FertilityDoula / Nutritionist - so GetCreditBalance now returns those 3 codes
// directly instead of the old 7. This map used to collapse the old 7 into these 3 buckets; now
// it's a straight 1:1 rename since the backend already groups them.
export const CREDIT_TYPE_CODE_TO_KEY = {
  Clinician: "clinician",
  FertilityDoula: "fertilityDoula",
  Nutritionist: "nutritionist",
};
